import React, { Fragment } from 'react'
// import LoaderImg from "../images/loader.gif"
import "./loading.css"


const LoaderBlock = () => {
  return (
    <Fragment>
      <section className="flex w-full min-h-[40vh]   justify-center items-center bg-white">
        <div className="relative flex items-center justify-center">

          {/* Spinning Circle */}
            <div class="loading">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>

        </div>
      </section>
    </Fragment>
  )
}



export default LoaderBlock
// import React, { Fragment } from 'react'
// // import LoaderImg from "../images/loader.gif"
// import "./loading.css"

// const LoaderBlock = () => {
//   return (
//     <Fragment>
//       <section className="flex w-full min-h-[30vh]   justify-center items-center bg-white">
//         <span className="loader" ></span>
//       </section>
//     </Fragment>
//   )
// }

// export default LoaderBlock